
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Schweden`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Schweiz (vor 11. Mai)`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Obligatorische Schulen`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Geöffnet`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Geschlossen`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Höhere Schulen`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Online`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Online`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Universitäten`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Online`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Online`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Läden (ausser Lebensmittel und Apotheken)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Geöffnet`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Geschlossen`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Cafés, Bars, Restaurants`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Geöffnet, es gelten Abstands`}{`­`}{`regeln`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Geschlossen`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Büros`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Geöffnet, Homeoffice empfohlen`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Geöffnet, Homeoffice empfohlen`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Versammlungen`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Maximal 50 Personen`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Maximal 5 Personen`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Nachtclubs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Geöffnet`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Geschlossen`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Museen`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Geöffnet`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Geschlossen`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Mit den beiden Lockerungsschritten am 27. April und am 11. Mai ist das öffentliche Leben in der Schweiz wieder erwacht: Die obligatorischen Schulen sind geöffnet; die Museen nehmen ihren Betrieb wieder auf; Restaurants dürfen wieder Gäste empfangen. Allerdings bestehen weiterhin wesentliche Unterschiede zu Schweden: Dort wurde das Nachtleben gar nie gestoppt, und öffentliche Versammlungen mit bis zu 50 Teilnehmern sind erlaubt. Zwar `}<a parentName="p" {...{
        "href": "https://www.folkhalsomyndigheten.se/the-public-health-agency-of-sweden/communicable-disease-control/covid-19/"
      }}>{`empfehlen`}</a>{` die schwedischen Gesundheitsbehörden, man soll auf «nicht essenzielle» Reisen verzichten und den öffentlichen Verkehr zu Stosszeiten meiden – die generelle Devise «Bleiben Sie zu Hause!» gilt jedoch nicht.`}</p>
    <p>{`Der «Government Response Stringency Index» der Universität Oxford misst, wie streng staatliche Eingriffe zur Eindämmung des Coronavirus sind. Er vergleicht systematisch Massnahmen in 17 verschiedenen Kategorien – wie etwa Reisebeschränkungen oder Contact-Tracing – und berechnet eine Punktzahl, die einen länderübergreifenden Vergleich ermöglicht. Die Schweizer Massnahmen seit dem 11. Mai liegen nur noch 24 Indexpunkte über den schwedischen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;